export default __webpack_public_path__ + "static/media/bg-2.632e2842.jpg";